import {Route, UrlSegment} from '@angular/router';
import {canAuthGuard} from '@shared/guards/can-auth-guard';
import {EEndpointApp} from '@shared/enums/endpoint-app.enum';
import {canActivateQrKindGuard} from '@shared/guards/can-activate-qr-kind.guard';
import {fnValidUuid} from '@shared/utils/fn.valid.uuid';
import {QR_CODE_TEMPLATE_ROUTE} from './template/template.routes';

export const QR_CODES_ROUTE: Route = {
  path: EEndpointApp.QrCode,
  canActivate: [canAuthGuard],
  children: [
    QR_CODE_TEMPLATE_ROUTE,
    {
      path: EEndpointApp.Overview,
      title: 'overview',
      loadComponent: () => import('./overview/overview.component').then((m) => m.OverviewComponent),
    },
    {
      path: EEndpointApp.ArchiveReview,
      title: 'archived_qr_codes',
      data: {
        isArchive: true,
      },
      loadComponent: () => import('./overview/overview.component').then((m) => m.OverviewComponent),
    },
    {
      path: EEndpointApp.Analytics,
      title: 'analytics',
      loadComponent: () => import('./analytics/analytics.component').then((m) => m.AnalyticsComponent),
    },
    {
      path: 'form',
      children: [
        {
          path: 'new',
          title: 'new_qrcode',
          children: [
            {
              path: '',
              loadComponent: () => import('./form/type/type.component').then((m) => m.TypeComponent),
            },
            {
              path: ':kind',
              canActivate: [canActivateQrKindGuard],
              loadComponent: () => import('./form/setup/setup.component').then((m) => m.SetupComponent),
            },
          ],
        },
      ],
    },
    {
      path: ':qrCodeId',
      canMatch: [
        (_route: Route, segments: UrlSegment[]) => {
          return fnValidUuid(segments[0]?.path);
        },
      ],
      children: [
        {
          path: EEndpointApp.View,
          title: 'qrcode_view',
          loadComponent: () => import('./view/view.component').then((m) => m.ViewComponent),
        },
        {
          path: EEndpointApp.Setup,
          title: 'qrcode_setting',
          loadComponent: () => import('./form/setup/setup.component').then((m) => m.SetupComponent),
        },
        {
          path: EEndpointApp.Design,
          title: 'qrcode_design',
          loadComponent: () => import('./form/design/design.component').then((m) => m.DesignComponent),
        },
      ],
    },
    {
      path: '',
      redirectTo: EEndpointApp.Overview,
      pathMatch: 'prefix',
    },
  ],
};
